import { render, staticRenderFns } from "./PluginSettings.vue?vue&type=template&id=dac15d6a&"
import script from "./PluginSettings.vue?vue&type=script&lang=ts&"
export * from "./PluginSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports